if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.initNavigation();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"]) `
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this.updateCounter();
      }

      initNavigation() {
        // Avoid duplicate listeners on re-open
        if (this._navInitialized) return;
        this._navInitialized = true;

        const prevBtn = this.querySelector('.product-media-modal__prev');
        const nextBtn = this.querySelector('.product-media-modal__next');

        if (prevBtn) prevBtn.addEventListener('click', () => this.navigateMedia(-1));
        if (nextBtn) nextBtn.addEventListener('click', () => this.navigateMedia(1));

        // Keyboard arrow navigation
        this.addEventListener('keydown', (e) => {
          if (!this.classList.contains('active')) return;
          if (e.key === 'ArrowLeft') this.navigateMedia(-1);
          if (e.key === 'ArrowRight') this.navigateMedia(1);
        });

        // Touch swipe support for mobile
        let touchStartX = 0;
        let touchStartY = 0;
        const content = this.querySelector('[role="document"]');
        if (content) {
          content.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
            touchStartY = e.changedTouches[0].screenY;
          }, { passive: true });

          content.addEventListener('touchend', (e) => {
            const deltaX = e.changedTouches[0].screenX - touchStartX;
            const deltaY = e.changedTouches[0].screenY - touchStartY;
            // Only trigger if horizontal swipe is dominant (not a scroll)
            if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 40) {
              this.navigateMedia(deltaX < 0 ? 1 : -1);
            }
          }, { passive: true });
        }
      }

      navigateMedia(direction) {
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        if (allMedia.length <= 1) return;

        const currentIndex = allMedia.findIndex((el) => el.classList.contains('active'));
        let nextIndex = currentIndex + direction;

        // Wrap around
        if (nextIndex < 0) nextIndex = allMedia.length - 1;
        if (nextIndex >= allMedia.length) nextIndex = 0;

        allMedia.forEach((el) => el.classList.remove('active'));
        const nextMedia = allMedia[nextIndex];
        nextMedia.classList.add('active');
        nextMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = (nextMedia.width - container.clientWidth) / 2;

        // Load deferred media (video) if needed
        const deferredMedia = nextMedia.querySelector('deferred-media');
        if (deferredMedia && nextMedia.nodeName === 'DEFERRED-MEDIA') nextMedia.loadContent?.();

        this.updateCounter();
      }

      updateCounter() {
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        const currentIndex = allMedia.findIndex((el) => el.classList.contains('active'));
        const currentEl = this.querySelector('.product-media-modal__counter-current');
        if (currentEl) currentEl.textContent = currentIndex + 1;
      }
    }
  );
}
